import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HomeService } from "../home/home.services";
import { Router } from "@angular/router";

@Component({
  selector: "app-userregister",
  templateUrl: "./userregister.component.html",
  styleUrls: ["./userregister.component.scss"],
})
export class UserregisterComponent implements OnInit {
  registrationForm!: FormGroup; // login form variable declaration to hold form values
  submitted = false;
  invalidCredentials = false;

  constructor(
    private formBuilder: FormBuilder,
    private homeservice: HomeService,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    localStorage.clear();
    this.registrationForm = this.formBuilder.group(
      {
        full_name: [
          "",
          [
            Validators.compose([
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(10),
            ]),
          ],
        ],
        email: ["", [Validators.required, Validators.email]], // email validations
        password: ["", [Validators.required, Validators.minLength(6)]],
        company_name: [
          "",
          [
            Validators.compose([
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(10),
            ]),
          ],
        ],
        is_manager: [false],
        username: ["", []],
      },
      {}
    );
    this.setUserCategoryValidators();
  }

  setUserCategoryValidators() {
    const companyControl = this.registrationForm.get("company_name");
    const userControl = this.registrationForm.get("username");

    this.registrationForm
      .get("is_manager")
      .valueChanges.subscribe((isMangar) => {
        if (isMangar) {
          userControl.setValidators([Validators.required]);
          companyControl.setValidators(null);
        } else {
          userControl.setValidators(null);
          companyControl.setValidators([
            Validators.compose([
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(10),
            ]),
          ]);
        }
        userControl.updateValueAndValidity();
        companyControl.updateValueAndValidity();
      });
  }
  get f() {
    return this.registrationForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registrationForm.invalid) {
      return;
    }
    this.homeservice.UserRegister(this.registrationForm.value).subscribe(
      (response) => {
        console.log("data", response);
        this.router.navigateByUrl("/home");
      },
      (err) => {
        console.log(err);
        this.invalidCredentials = true;
        this.toastr.error(
          typeof err === "string"
            ? err
            : err.message || "Login process errored."
        );
      }
    );
  }

  hideoshow() {
    var checkBox = document.getElementById("checkbox");
    const username = this.registrationForm.controls["is_manager"].value;
    var text = document.getElementById("username");
    var companyname = document.getElementById("companyname");
    if (username == false) {
      companyname.style.display = "none";
      text.style.display = "block";
    } else {
      text.style.display = "none";
      companyname.style.display = "block";
    }
  }
}
